import { render, staticRenderFns } from "./VideoActionsButtons.vue?vue&type=template&id=6c784004&scoped=true"
import script from "./VideoActionsButtons.vue?vue&type=script&lang=js"
export * from "./VideoActionsButtons.vue?vue&type=script&lang=js"
import style0 from "./VideoActionsButtons.vue?vue&type=style&index=0&id=6c784004&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c784004",
  null
  
)

export default component.exports